<template>
  <div class="group-buy-detail"  :class="[{ inApp: $root.$data.isApp }]">
    <common-title titleName="拼团详情" :zIndex="1000" @goBack="goBack"/>
    <div class="banner">
      <img class="main_img" :src="courseDetail.coverMobile" alt="" />
    </div>
    <!-- 活动价格 -->
<!--    <AcvitityPrice />-->
    <!--  课程本名称、课时等  -->
    <div class="basicInformation">
      <CourseNameModule/>
    </div>
    <!--  课程价格  -->
    <div class="group-price" v-if="productSku.groupActivity">
      <span>拼团价：￥</span>
      <span>{{ groupPrice }}</span>
      <span>￥{{ originalPrice }}</span>
    </div>
    <!--  课程选择  -->
    <CourseSelect/>
    <!-- 拼团详情 -->
    <GroupBuyCard :groupDetail="groupDetail" v-if="!isInit" @openWechatOverlay="openWechatOverlay"/>
    <div class="course-introduce-div">
      <div class="title">课程介绍</div>
      <div class="courseIntroduce" v-html="introduction.introduction"></div>
    </div>
    <commonLoading v-if="loading"/>
    <van-overlay :show="overlayShow" z-index="1999" :lock-scroll="true">
      <div class="wrapper" @click="overlayShow = false" @click.stop>
        <img src="../../../../assets/img/public/wechartShare.png"/>
      </div>
    </van-overlay>
    <img src="../../../../assets/img/logo_icon.png" alt="" ref="logoIcon" class="logo-icon-hide">
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { reqCourseDetailStreamline } from '@/api/courseDetail';
import CourseNameModule from '@/components/courseDetail/courseNameModule/CourseNameModule.vue';
// import CoursePrice from '@/components/courseDetail/CoursePrice.vue';
// import AcvitityPrice from '@/pages/courseDetail/courseActivity/acvitityPrice.vue';
import CourseSelect from '@/components/courseDetail/CourseSelect.vue';
import GroupBuyCard from '@/pages/courseDetail/courseActivity/groupBuy/GroupBuyCard.vue';
import { reqGetGroupDetail } from '@/api/courseDetail/groupBuy/groupBuy';
// import { reqGetGroupOrderDetail } from '@/api/personal';
import commonLoading from '@/components/commonComponents/CommonLoading.vue';

export default {
  components: {
    CourseNameModule,
    // CoursePrice,
    // AcvitityPrice,
    CourseSelect,
    GroupBuyCard,
    commonLoading,
  },
  data() {
    return {
      courseDetail: {},
      courseId: this.$route.query.courseId,
      introduction: '',
      groupDetail: {},
      isInit: true,
      groupPrice: 0,
      originalPrice: 0,
      loading: true,
      goBackDefault: false, // 顶部返回键，分享页面后，首次进入时，点击回退到首页。刷新时，点击正常返回。
      overlayShow: false,
    };
  },
  computed: {
    ...mapState([
      'courseBaseData',
      'userInfo',
      'allAcvitity',
      'groupBuyDetailVuex',
      'productSku',
    ]),
  },
  async mounted() {
    this.routeQuery = this.$route.query;
    this.init();
    this.loading = true;
    this.$nextTick(() => {
      document.documentElement.scrollTop = 0;
    });
  },
  methods: {
    openWechatOverlay() {
      this.overlayShow = true;
    },
    async weixinInit() {
      const shareImgUrl = this.$refs.logoIcon.src;
      const { groupActivityDiscountVOS } = this.groupBuyDetailVuex;
      // eslint-disable-next-line no-param-reassign,no-return-assign
      const { groupPrice } = groupActivityDiscountVOS.filter((item) => item.productSkuId = this.groupBuyDetailVuex.productSkuId)[0];
      const title = `【仅剩${this.groupDetail.groupNumber - this.groupDetail.joinNumber}个名额】我用${groupPrice}元拼了${this.courseDetail.name}`;
      const content = `我在启航教育参与拼团活动，还差${this.groupDetail.groupNumber - this.groupDetail.joinNumber}人拼团成功，快来参与吧~`;
      // pc端微信浏览器对新版本updateAppMessageShareData不支持
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('iphone') > -1 || ua.indexOf('ndroid') > -1) {
        wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
          // alert(location.href.split('#')[0])
          wx.updateAppMessageShareData({
            title, // 分享标题
            desc: content, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImgUrl, // 分享图标
          });
          wx.updateTimelineShareData({
            title, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImgUrl, // 分享图标
            success() {
              // 设置成功
            },
          });
        });
      } else {
        wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
          wx.onMenuShareTimeline({
            title, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImgUrl, // 分享图标
            success() {
              // 用户点击了分享后执行的回调函数
            },
          });

          wx.onMenuShareAppMessage({
            title, // 分享标题
            desc: content, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImgUrl, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success() {
              // 用户点击了分享后执行的回调函数
            },
          });
        });
      }
    },

    goBack() {
      if (this.goBackDefault) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: this.groupDetail.productId,
          },
        });
      }
    },
    init() {
      this.isInit = true;
      // 包含订单号时，为支付成功页跳转，需先获取订单详情
      /* if (this.routeQuery.groupOrderNo) {
        reqGetGroupOrderDetail({ groupOrderNo: this.routeQuery.groupOrderNo }).then((res) => {
          if (res.code === 0) {
            this.getGroupDetail(res.data.groupId);
          } else if (res.code === 1000) {
            // 未登录状态
            this.$router.push({
              path: '/registrationLogin',
              query: { redirect: this.$route.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
            });
          } else if (res.code === 6016) {
            // 用户无权限查看此订单
            this.$router.push({
              path: '/',
            });
          } else {
            this.loading = false;
            this.$toast('获取订单信息失败');
          }
        }).catch((err) => {
          if (JSON.stringify(err.message).indexOf('401') > -1) {
            // 未登录状态
            this.$router.push({
              path: '/registrationLogin',
              query: { redirect: this.$route.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
            });
          }
        });
      } else */
      if (this.routeQuery.groupId) {
        this.getGroupDetail(this.routeQuery.groupId);
      } else {
        this.$toast('无法获取拼团信息');
      }
    },

    async getGroupDetail(groupId) {
      const res = await reqGetGroupDetail({
        groupId,
      });
      this.isInit = false;
      if (res.code === 0) {
        this.groupDetail = res.data;
        const { groupOrderRespVOS, userRespVOS } = res.data;
        // eslint-disable-next-line no-unused-expressions
        groupOrderRespVOS?.forEach((item) => {
          const user = userRespVOS.filter((val) => val.id === item.userId);
          // eslint-disable-next-line no-param-reassign,prefer-destructuring
          item.userInfo = user[0];
        });
        // console.log(this.groupDetail);
        this.$store.dispatch('saveGroupBuyDetailVuex', this.groupDetail);
        this.getCourseDetail(res.data.productId);
      }
    },

    async getCourseDetail(courseId) {
      const res = await reqCourseDetailStreamline(courseId);
      this.loading = false;
      if (res.code === 0) {
        this.courseDetail = res.data;
        if (res.data && res.data.productIntroductionRespVOList) {
          this.introduction = res.data.productIntroductionRespVOList.find(
            (ele) => ele.terminalType === 2,
          );
        }
        const { productSkuRespVOList } = this.courseDetail;
        const { groupActivityDiscountVOS } = this.groupDetail;
        productSkuRespVOList.forEach((item) => {
          if (groupActivityDiscountVOS) {
            const temp = groupActivityDiscountVOS.filter((val) => val.productSkuId === item.productSkuId);
            // eslint-disable-next-line no-param-reassign,prefer-destructuring
            item.groupActivity = temp[0];
          }
        });
        if (this.$root.$data.isWeiXin) {
          this.weixinInit();
        }
        // console.log(this.courseDetail);
        this.$store.dispatch('saveCourseBaseData', this.courseDetail);
      }
    },
  },
  watch: {
    productSku(val) {
      this.originalPrice = val.groupActivity?.price;
      this.groupPrice = val.groupActivity?.groupPrice;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.goBackDefault = sessionStorage.getItem('webLoadMode') === 'refresh';
    });
  },
};
</script>

<style scoped lang="scss">
.group-buy-detail{
  .banner{
    width: 100%;
    height: 543px;
    margin-top: 100px;
    img{
      width: 100%;
      height: 543px;
    }
  }
  .basicInformation {
    //基本信息模块
    width: 100%;
    padding: 36px 36px 0;
    background-color: #fff;
  }
  .coursePriceModule {
    width: 100%;
    overflow: hidden;
    background-color: #fff;
    border-radius: 0 0 14px 14px;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
  }

  .course-introduce-div{
    margin-top: 22px;
    background: white;
    border-radius: 14px 14px 0 0;

    .title {
      width: 100%;
      padding: 27px 0;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid #F5F5F5;
    }
    .courseIntroduce {
      width: 100%;
      padding: 22px;
      font-size: 28px;
      ::v-deep img {
        width: 100%;
      }
    }
  }

  .group-price {
    width: 100%;
    margin-top: -14px;
    padding: 0 36px 36px;
    background: white;

    span{
      &:nth-child(1){
        color: #FF6C02;
        font-weight: 500;
        font-size: 33px;
        line-height: 45px;
      }
      &:nth-child(2){
        color: #FF6C02;
        font-weight: 500;
        font-size: 43px;
        line-height: 60px;
      }
      &:nth-child(3){
        margin-left: 18px;
        color: #787878;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
        text-decoration: line-through;
      }
    }
  }
  .logo-icon-hide{
    display: none;
  }
}
.wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  img{
    position: absolute;
    top: 0;
    right: 51px;
    width: 397px;
    height: 270px;
  }
}
.inApp {
  .banner {
    margin-top: 0;
  }
}
</style>
